import React from 'react';
import { useParams } from 'react-router-dom';
import ArtistBillingSettings from 'components/artists/billing/ArtistBillingSettings';

const ArtistBillingSettingsPage: React.FC = () => {
  const { artistId } = useParams<{ artistId: string }>();

  if (!artistId) {
    return <p className="p-6 text-red-600">Artist ID not found in route.</p>;
  }

  return <ArtistBillingSettings artistId={artistId} />;
};

export default ArtistBillingSettingsPage;
